import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import ImageService from '../services/ImageService';

import Clickable from './Clickable';

import photoStyles from './InputFile.scss';

import add_photo from './add_photo.png';

class InputFile extends Component {
  constructor(props) {
    super(props);
    this.fileInput = React.createRef();
  }

  state = {
    temporaryImageUrl: null,
    imageWidth: 0,
    imageHeight: 0,
  };

  handleFileUpload = e => {
    const { onPhotoUpload, index, allowedTypes } = this.props;

    const file = e.target.files[0];
    if (
      allowedTypes &&
      allowedTypes.length &&
      !allowedTypes.includes(file.type)
    ) {
      return false;
    }
    const temporaryImageUrl = URL.createObjectURL(file);

    if (!this.state.temporaryImageUrl && onPhotoUpload) {
      onPhotoUpload(file, index);
    }

    const image = new Image();
    image.addEventListener('load', () => {
      this.setState({
        imageHeight: image.naturalHeight,
        imageWidth: image.naturalWidth,
      });
    });
    image.src = temporaryImageUrl;

    this.setState({ temporaryImageUrl });
  };

  handleContainerSelection = () => {
    const { temporaryImageUrl } = this.state;
    const { onSelect, index, allowedTypes } = this.props;

    const file = this.fileInput.current.files[0];
    if (
      allowedTypes &&
      allowedTypes.length &&
      !allowedTypes.includes(file.type)
    ) {
      return false;
    }
    if (onSelect) {
      onSelect(file, index);
    }
  };

  handlePhotoRemoval = e => {
    const { onPhotoRemove, image } = this.props;
    e.stopPropagation();

    if (image) {
      onPhotoRemove(image)
        .then(res => {
          this.setState({ temporaryImageUrl: null });
        })
        .catch(err => {
          console.error(err);
        });
    } else {
      this.setState({ temporaryImageUrl: null });
    }
  };

  handleContainerClick = e => {
    const { temporaryImageUrl } = this.state;
    const { onSelect } = this.props;

    e.stopPropagation();
    if (temporaryImageUrl && onSelect) {
      this.handleContainerSelection();
    } else {
      this.fileInput.current.click();
    }
  };

  renderPlaceholder = () => {
    const { text, styleLikeButton } = this.props;

    return (
      <Fragment>
        {!styleLikeButton && (
          <div className={photoStyles.placeholderImageContainer}>
            <img src={add_photo} height={50} />
          </div>
        )}
        <p className={photoStyles.text}>{text}</p>
      </Fragment>
    );
  };

  renderPhoto = () => {
    const { image } = this.props;
    const { temporaryImageUrl, imageHeight, imageWidth } = this.state;

    const style = {
      minHeight: imageHeight < imageWidth ? 160 : '',
      maxHeight: imageHeight < imageWidth ? 160 : '',
      minWidth: imageHeight > imageWidth ? 160 : '',
      maxWidth: imageHeight > imageWidth ? 160 : 'none',
    };

    return (
      <div className={photoStyles.temporaryImage}>
        {image && image.image ? (
          <img
            src={ImageService().getFull(image.image, {
              'min-w': 180,
              'min-h': 180,
              fit: 'crop',
            })}
            height={180}
            width={180}
            options={{}}
          />
        ) : (
          <img
            src={temporaryImageUrl}
            style={{ maxWidth: 'none', ...style, position: 'absolute' }}
          />
        )}
      </div>
    );
  };

  renderCloseButton = () => {
    const { disabled } = this.props;

    return (
      <Clickable
        disabled={disabled}
        className={photoStyles.closeButton}
        onClick={this.handlePhotoRemoval}
      >
        <div className={`qm-icon-close ${photoStyles.closeButtonIcon}`} />
      </Clickable>
    );
  };

  render() {
    const {
      styleLikeButton,
      className,
      style,
      image,
      disabled,
      loading,
    } = this.props;
    const { temporaryImageUrl } = this.state;

    const hasImage = (image && image.image) || temporaryImageUrl;

    return (
      <Clickable
        loading={loading}
        disabled={disabled}
        style={style}
        className={`${
          styleLikeButton
            ? photoStyles.containerButton
            : photoStyles.containerBox
        } ${className}`}
        onClick={this.handleContainerClick}
      >
        {hasImage && !styleLikeButton && this.renderCloseButton()}
        {hasImage && !styleLikeButton
          ? this.renderPhoto()
          : this.renderPlaceholder()}
        <input
          ref={this.fileInput}
          style={{ visibility: 'hidden', height: 0 }}
          type="file"
          height={0}
          width={0}
          onChange={this.handleFileUpload}
        />
      </Clickable>
    );
  }
}

InputFile.propTypes = {
  style: PropTypes.object,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
  styleLikeButton: PropTypes.bool,
  onPhotoUpload: PropTypes.func,
  image: PropTypes.object,
  loading: PropTypes.bool,
  allowedTypes: PropTypes.array,
};

export default InputFile;
